import script from "./bankRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./bankRegister.vue?vue&type=script&setup=true&lang=js"

import "./bankRegister.vue?vue&type=style&index=0&id=7d71d4d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d71d4d6"]])

export default __exports__